import type { FC } from 'react';
import { Typography } from '@mui/material';

import { useBasicTicketCost } from '@mopla/business-logic';
import { FlexContainer } from '@mopla/ui';
import { formatPrice } from '@mopla/utils';

import { usePriceInfoBlock } from './usePriceInfoBlock';

interface IProps {
	priceToPay?: number;
}

export const PriceInfoBlock: FC<IProps> = ({ priceToPay }) => {
	const { basicTicketCost } = useBasicTicketCost();

	const price = formatPrice(priceToPay ?? basicTicketCost);

	const { priceTitleId, priceToPayId, priceTitle, priceToPayText } =
		usePriceInfoBlock(price);

	return (
		<FlexContainer className="spaceBetween">
			<Typography
				data-testid={priceTitleId}
				variant="body1"
				fontWeight={600}
				color="neutral.0"
			>
				{priceTitle}
			</Typography>
			<Typography
				data-testid={priceToPayId}
				variant="body1"
				fontWeight={600}
				color="neutral.0"
			>
				{priceToPayText}
			</Typography>
		</FlexContainer>
	);
};
